package com.hyperether.goodjob.scenes.profile

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.IconButton
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.navigation.NavHostController
import com.hyperether.goodjob.boxCornerShape
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.log
import com.hyperether.goodjob.models.Plan
import com.hyperether.goodjob.models.Role
import com.hyperether.goodjob.navigation.AddNewUser
import com.hyperether.goodjob.repository.prefs.PrefsManager
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.before_you_proceed
import com.hyperether.goodjob.resources.cancel_subscription
import com.hyperether.goodjob.resources.change_or_upgrade_subscription
import com.hyperether.goodjob.resources.change_plan
import com.hyperether.goodjob.resources.choose_plan
import com.hyperether.goodjob.resources.contacting_support_for_assistance
import com.hyperether.goodjob.resources.continue_cancellation
import com.hyperether.goodjob.resources.downgrading_to_lower
import com.hyperether.goodjob.resources.edit
import com.hyperether.goodjob.resources.error
import com.hyperether.goodjob.resources.ic_back
import com.hyperether.goodjob.resources.keep_my_subscription
import com.hyperether.goodjob.resources.manage_subscription
import com.hyperether.goodjob.resources.ok
import com.hyperether.goodjob.resources.profile_settings
import com.hyperether.goodjob.resources.settings
import com.hyperether.goodjob.resources.subscription
import com.hyperether.goodjob.resources.success
import com.hyperether.goodjob.resources.team_members_linked
import com.hyperether.goodjob.resources.what_happens
import com.hyperether.goodjob.resources.you_will_lose
import com.hyperether.goodjob.resources.your_data_will
import com.hyperether.goodjob.scenes.components.DetailsCards
import com.hyperether.goodjob.scenes.components.ErrorDialog
import com.hyperether.goodjob.scenes.components.PopUpDialog
import com.hyperether.goodjob.scenes.components.SubscriptionToggle
import com.hyperether.goodjob.scenes.components.WebViewHeader
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.pricing.BulletPointText
import com.hyperether.goodjob.scenes.pricing.PricingScreen
import com.hyperether.goodjob.scenes.pricing.PricingViewModel
import com.hyperether.goodjob.scenes.register.FilledButton
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.theme.DashboardBg
import com.hyperether.goodjob.theme.GrayButton
import com.hyperether.goodjob.theme.LightGray
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.currentLanguage
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun SettingsWeb(
    isMobileView: Boolean,
    navHostController: NavHostController,
    prefsManager: PrefsManager,
    viewModel: PricingViewModel,
    profileViewModel: ProfileViewModel,
    onChoosePlanClick: (Double, String) -> Unit
) {
    val selectedCard = remember { mutableStateOf(0) }
    val showCancelSubscriptionView = remember { mutableStateOf(false) }
    val user = prefsManager.getUser()

    val plans = if (getPlatformChecker().isMobile()) {
        viewModel.plans.collectAsState().value
    } else {
        viewModel.plansRemote.collectAsState().value.sortedBy { it.price }
    }
    var existingPlan by remember { mutableStateOf<Plan?>(null) }
    val freebiePlan = plans.find {
        it.price == 0.0
    }

    LaunchedEffect(Unit) {
        viewModel.init()
        prefsManager.getUser()?.let {
            it.pendingPlanId?.let { pendingPlanId -> viewModel.getPlanById(pendingPlanId) }
        }
        viewModel.selectedPlanId.value = ""
    }

    LaunchedEffect(plans, viewModel.selectedPlanId.value) {
        existingPlan = plans.firstOrNull { it._id == viewModel.getUser()?.planId }
            ?: viewModel.getPlanFromWorkspace()
    }

    LaunchedEffect(plans) {
        if (plans.isNotEmpty()) {
            val popularPlan = plans.find { it.isPopular == true }
            viewModel.selectedPlan.value =
                if (!viewModel.isNavigationSourceDrawer.value) popularPlan?.getName(
                    currentLanguage.value.code
                )
                else existingPlan?.getName(currentLanguage.value.code)
            viewModel.selectedPlanId.value =
                if (!viewModel.isNavigationSourceDrawer.value) popularPlan?._id
                else existingPlan?._id

            viewModel.showLoader.value = false
        }
    }

    LaunchedEffect(isMobileView) {
        viewModel.getAllPlans()
    }

    fun updateFilteredPlans() {
        viewModel.filteredPlans.value = emptyList()
        val newFilteredPlans = mutableListOf<Plan>()

        if (freebiePlan != null) {
            newFilteredPlans.add(freebiePlan)
        }

        val selectedInterval = when {
            viewModel.selectedOption.value.startsWith("year", ignoreCase = true) -> "year"
            viewModel.selectedOption.value.startsWith("month", ignoreCase = true) -> "month"
            else -> null
        }

        if (selectedInterval != null) {
            val matchingPlans = plans.filter {
                it.interval.equals(selectedInterval, ignoreCase = true) && it.price != 0.0
            }

            newFilteredPlans.addAll(matchingPlans)
        }

        viewModel.filteredPlans.value = newFilteredPlans
        log.d("Pricing") { "Filtered plans: ${viewModel.filteredPlans.value}" }
    }

    LaunchedEffect(viewModel.selectedOption.value, plans) {
        updateFilteredPlans()
    }

    val isAdmin = user?.role == Role.admin.name || user?.role == Role.superAdmin.name
    val scrollState = rememberScrollState()
    if (!isMobileView) {
        Column(
            modifier = Modifier.fillMaxSize().background(DashboardBg)
                .verticalScrollbar(scrollState)
                .verticalScroll(scrollState)
                .disableMouseDragScrollOnWeb()
        ) {
            WebViewHeader(
                isBackAvailable = false,
                title = stringResource(Res.string.settings),
                onBackClick = { navHostController.navigateUp() },
                isImportAndAddVisible = false,
                navHostController = navHostController
            )
            Spacer(modifier = Modifier.height(15.toScaleDp()))

            // Form container
            Box(
                modifier = Modifier.fillMaxSize().padding(bottom = 15.toScaleDp())
            ) {
                Row(
                    modifier = Modifier.padding(horizontal = 75.toScaleDp())
                        .fillMaxHeight()
                        .background(Color.White, shape = boxCornerShape())
                        .border(
                            width = 1.toScaleDp(),
                            shape = boxCornerShape(),
                            color = BorderColor
                        )
                ) {
                    if (!viewModel.isEmployee()) {
                        DetailsCards(
                            titles = listOf(
                                stringResource(Res.string.subscription),
                                stringResource(Res.string.profile_settings)
                            ),
                            modifier = Modifier.width(200.toScaleDp()),
                            selectedCard = selectedCard
                        )
                    } else {
                        DetailsCards(
                            titles = listOf(
                                stringResource(Res.string.profile_settings)
                            ),
                            modifier = Modifier.width(200.toScaleDp()),
                            selectedCard = selectedCard
                        )
                        selectedCard.value = 1
                    }
                    Column(
                        modifier = Modifier.fillMaxHeight().weight(1f).drawBehind {
                            drawLine(
                                color = BorderColor,
                                start = Offset(0f, 0f),
                                end = Offset(0f, size.height),
                                strokeWidth = 1f
                            )
                        }.padding(horizontal = 40.toScaleDp(), vertical = 40.toScaleDp())

                    ) {
                        if (selectedCard.value == 1) {
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.SpaceBetween
                            ) {
                                Text(
                                    text = stringResource(Res.string.profile_settings),
                                    fontSize = 27.toScaleSp(),
                                    lineHeight = 30.toScaleSp(),
                                    color = Color.Black,
                                    fontWeight = FontWeight.W700,
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                                Spacer(modifier = Modifier.weight(1f))
                                Row(modifier = Modifier.clickableWithPointer {
                                    navHostController.navigate(AddNewUser("profileSettings-${user?._id}"))
                                }) {
                                    Image(
                                        painter = painterResource(Res.drawable.edit),
                                        contentDescription = "",
                                        modifier = Modifier.padding(
                                            end = 16.toScaleDp(), top = 10.toScaleDp()
                                        ).size(20.toScaleDp())
                                    )
                                    DisableSelection {
                                        Text(
                                            modifier = Modifier.padding(top = 10.toScaleDp()),
                                            text = stringResource(Res.string.edit),
                                            fontSize = 18.toScaleSp(),
                                            fontWeight = FontWeight.Normal,
                                            maxLines = 1,
                                            overflow = TextOverflow.Ellipsis
                                        )
                                    }
                                }

                            }
                            Spacer(modifier = Modifier.height(30.toScaleDp()))
                            ProfileSettingsWeb(user)
                        } else {
                            if (!showCancelSubscriptionView.value) {
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .wrapContentHeight()
                                ) {
                                    Text(
                                        text = stringResource(Res.string.subscription),
                                        fontSize = 27.toScaleSp(),
                                        lineHeight = 30.toScaleSp(),
                                        color = Color.Black,
                                        fontWeight = FontWeight.W700,
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                    Spacer(modifier = Modifier.height(25.toScaleDp()))
                                    Column(
                                        modifier = Modifier.fillMaxWidth(),
                                        horizontalAlignment = Alignment.CenterHorizontally
                                    ) {
                                        Text(
                                            text = stringResource(Res.string.manage_subscription),
                                            fontSize = 35.toScaleSp(),
                                            lineHeight = 62.toScaleSp(),
                                            color = Color.Black,
                                            fontWeight = FontWeight.W700,
                                            textAlign = TextAlign.Center,
                                            modifier = Modifier.padding(vertical = 16.toScaleDp()),
                                            maxLines = 1,
                                            overflow = TextOverflow.Ellipsis
                                        )
                                        if (isAdmin) {
                                            Text(
                                                text = stringResource(Res.string.change_or_upgrade_subscription),
                                                fontSize = 18.toScaleSp(),
                                                lineHeight = 25.toScaleSp(),
                                                fontWeight = FontWeight.Normal,
                                                color = Color.Gray,
                                                textAlign = TextAlign.Center,
                                                maxLines = 1,
                                                overflow = TextOverflow.Ellipsis
                                            )
                                            Spacer(modifier = Modifier.height(25.toScaleDp()))
                                        }
                                        SubscriptionToggle(
                                            isDark = false,
                                            isMobile = isMobileView,
                                            traceColor = LightGray,
                                            selectedOption = viewModel.selectedOption.value,
                                            onOptionSelected = {
                                                viewModel.selectedOption.value = it
                                                updateFilteredPlans()
                                            })
                                        Spacer(modifier = Modifier.height(15.toScaleDp()))
                                        Box(
                                            modifier = Modifier.fillMaxWidth(),
                                            contentAlignment = Alignment.Center,
                                        ) {
                                            prefsManager.getUser()?.let {
                                                Column(
                                                    horizontalAlignment = Alignment.CenterHorizontally
                                                ) {
                                                    DisableSelection {
                                                        PricingBoxSubscription(
                                                            filteredPlans = viewModel.filteredPlans.value,
                                                            selectedPlanId = viewModel.selectedPlanId,
                                                            user = user,
                                                            plans = plans,
                                                            onClick = { plan ->
                                                                viewModel.selectedPlan.value =
                                                                    plan.getName(currentLanguage.value.code)
                                                                viewModel.selectedPlanId.value =
                                                                    plan._id
                                                                viewModel.amount.value = plan.price
                                                                viewModel.currency.value =
                                                                    plan.currency
                                                            },
                                                            workspacePlan = existingPlan?._id
                                                        )
                                                    }
                                                    if (user?.pendingPlanId != null) {
                                                        val downgradeText =
                                                            viewModel.getPlanChangeMessage()
                                                        Text(
                                                            text = downgradeText,
                                                            fontSize = 12.toScaleSp(),
                                                            color = Color.Gray
                                                        )
                                                    }
                                                }
                                            }
                                        }
                                        if (isAdmin) {
                                            Spacer(modifier = Modifier.height(20.toScaleDp()))
                                            FilledButton(
                                                onClick = {
                                                    viewModel.setNavigationFromDrawer(true)
                                                    val selectedPlan =
                                                        viewModel.filteredPlans.value.find { it._id == viewModel.selectedPlanId.value }
                                                    println("PLAN" + selectedPlan.toString())
                                                    selectedPlan?.let { plan ->
                                                        plan.currency?.let { currency ->
                                                            plan.price?.let {
                                                                onChoosePlanClick(
                                                                    it,
                                                                    currency
                                                                )
                                                            }
                                                        }
                                                    }
                                                },
                                                modifier = Modifier.width(200.toScaleDp()),
                                                text = if (existingPlan == null) stringResource(Res.string.choose_plan) else stringResource(
                                                    Res.string.change_plan
                                                ),
                                                isEnabled = existingPlan?._id != viewModel.selectedPlanId.value,
                                                color = if (existingPlan == null) BlueApp else {
                                                    if (existingPlan?._id == viewModel.selectedPlanId.value) {
                                                        GrayButton
                                                    } else {
                                                        BlueApp
                                                    }
                                                }
                                            )
                                            Spacer(modifier = Modifier.height(25.toScaleDp()))
                                            DisableSelection {
                                                Text(
                                                    text = stringResource(Res.string.cancel_subscription),
                                                    fontSize = 12.toScaleSp(),
                                                    fontWeight = FontWeight.Normal,
                                                    color = Color.Gray,
                                                    textAlign = TextAlign.Center,
                                                    modifier = Modifier.clickableWithPointer {
                                                        showCancelSubscriptionView.value = true
                                                    },
                                                    maxLines = 1,
                                                    overflow = TextOverflow.Ellipsis
                                                )
                                            }
                                        }
                                    }
                                }
                            } else {
                                Row {
                                    IconButton(
                                        onClick = {
                                            showCancelSubscriptionView.value = false
                                        }
                                    ) {
                                        Image(
                                            painter = painterResource(Res.drawable.ic_back),
                                            contentDescription = "Back button"
                                        )
                                    }
                                    DisableSelection {
                                        Text(
                                            text = stringResource(Res.string.cancel_subscription),
                                            fontSize = 27.toScaleSp(),
                                            lineHeight = 30.toScaleSp(),
                                            color = Color.Black,
                                            fontWeight = FontWeight.W700,
                                            modifier = Modifier.padding(top = 10.toScaleDp()),
                                            maxLines = 1,
                                            overflow = TextOverflow.Ellipsis
                                        )
                                    }
                                }
                                Spacer(modifier = Modifier.height(15.toScaleDp()))

                                CancelSubscriptionView(viewModel, {
                                    showCancelSubscriptionView.value = false
                                })
                            }
                        }
                    }
                }
            }
        }
    } else {
        if (selectedCard.value == 0) {
            PricingScreen(isMobileView, viewModel, navHostController, onChoosePlanClick)
        }
        if (selectedCard.value == 1) {
            ProfileSettings(navHostController, prefsManager, profileViewModel)
        }
    }
    if (viewModel.showPopUpError.value) {
        DisableSelection {
            ErrorDialog(
                onDismiss = { viewModel.showPopUpError.value = false },
                title = org.jetbrains.compose.resources.stringResource(Res.string.error)
                    .uppercase(),
                message = viewModel.errorMessageTextChangePlan.value.ifEmpty { viewModel.messageText.value }
            )
        }
    }
    if (viewModel.showPopUpSuccess.value) {
        DisableSelection {
            PopUpDialog(
                onDismiss = {
                    viewModel.showPopUpSuccess.value = false
                    navHostController.popBackStack()
                },
                title = stringResource(Res.string.success).uppercase(),
                message = viewModel.messageText.value,
                positiveBtnText = stringResource(Res.string.ok),
                onPositiveBtnClicked = {
                    viewModel.showPopUpSuccess.value = false
                    navHostController.popBackStack()
                }
            )
        }
    }
}

@Composable
fun CancelSubscriptionView(viewModel: PricingViewModel, onKeepSubscription: () -> Unit) {

    Column(
        modifier = Modifier.fillMaxWidth(),
        // horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            stringResource(Res.string.what_happens),
            color = Color(0xFF111111),
            fontSize = 16.toScaleSp(),
            fontWeight = FontWeight.W700,
            modifier = Modifier.padding(bottom = 14.toScaleDp()),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        Column(modifier = Modifier.padding(bottom = 30.toScaleDp())) {
            BulletPointText(stringResource(Res.string.you_will_lose))
            BulletPointText(stringResource(Res.string.your_data_will))
            BulletPointText(stringResource(Res.string.team_members_linked))
        }
        Text(
            stringResource(Res.string.before_you_proceed),
            color = Color(0xFF111111),
            fontSize = 16.toScaleSp(),
            fontWeight = FontWeight.W700,
            modifier = Modifier.padding(bottom = 14.toScaleDp()),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        Column(modifier = Modifier.padding(bottom = 30.toScaleDp())) {
            BulletPointText(stringResource(Res.string.downgrading_to_lower))
            BulletPointText(stringResource(Res.string.contacting_support_for_assistance))
        }
        Row {
            androidx.compose.material3.OutlinedButton(
                onClick = {
                    onKeepSubscription()
                },
                border = BorderStroke(1.toScaleDp(), BlueApp),
                colors = androidx.compose.material3.ButtonDefaults.outlinedButtonColors(
                    contentColor = Color.White, containerColor = Color.Transparent
                ),
                shape = RoundedCornerShape(25.toScaleDp()),
                modifier = Modifier
                    .width(320.toScaleDp())
                    .height(50.toScaleDp())
                    .pointerHoverIcon(PointerIcon.Hand)
            ) {
                DisableSelection {
                    Text(
                        stringResource(Res.string.keep_my_subscription), color = BlueApp,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
            }
            Spacer(modifier = Modifier.width(30.toScaleDp()))
            Box(
                modifier = Modifier
                    .height(50.toScaleDp())
                    .clickableWithPointer {
                        viewModel.cancelSubscription()
                    },
                contentAlignment = Alignment.Center
            ) {
                DisableSelection {
                    Text(
                        stringResource(Res.string.continue_cancellation),
                        color = BlueApp,
                        fontSize = 16.toScaleSp(),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
            }
        }
    }
}